<template>
  <td>
    {{ $e("Status")}} :
  </td>
  <td>
    <template v-if="config?.dock?.id">
      {{ DockStateTexte }}
    </template>
    <template v-else-if="config?.rcPlus?.id">
      {{ RcPlusStateTexte }}
    </template>
  </td>
  <td>
    <div v-html="svg"></div>
  </td>
</template>
<script>
import { ref } from 'vue';

export default {
  props: {
    config: Object,
    cheack: Object,
  },

  setup() {
    return {
      svg: ref(""),
    }
  },

  mounted() {
    if (this.config?.dock?.id) {
      this.DockCheack();
    }
    else if (this.config?.rcPlus?.id) {
      this.RcPlusCheack();
    }
  },

  computed: {
    DockStateTexte() {
      let mode_code = this.config?.dock?.status?.mode_code != undefined
        ? this.config.dock?.status.mode_code
        : ENV.NO_DATA;

      return this.$root.status_dock.hasOwnProperty(mode_code)
        ? this.$root.status_dock[mode_code]
        : mode_code;
    },

    RcPlusStateTexte() {
      let LastPing = this.config?.rcPlus?.status?.LastPing != null
        ? parseInt(this.config.rcPlus.status.LastPing)
        : 0;

      if (LastPing > ENV.DEVICE_OFFLINE) {
        return "Hors ligne";
      }
      return "En ligne";
    },

  },
  methods: {
    DockCheack() {
      let mode_code = this.config?.dock?.status?.mode_code != undefined
        ? this.config.dock?.status.mode_code
        : -1;

      if (mode_code == 0) {
        this.svg = this.cheack.ok;
      }
      else if (mode_code == 14 || mode_code == -1) {
        this.svg = this.cheack.nok;
      }
      else {
        this.svg = this.cheack.warning;
      }
    },
    RcPlusCheack() {
      let LastPing = this.config?.rcPlus?.status?.LastPing != null
        ? parseInt(this.config.rcPlus.status.LastPing)
        : 0;

      this.svg = LastPing > ENV.DEVICE_OFFLINE
        ? this.cheack.nok
        : this.cheack.ok;
    }
  },
  watch: {
    'config.dock.status.mode_code': {
      handler(newVal, oldVal) {
        if (newVal == oldVal) return;
        this.DockCheack();
      },
      deep: true,
    },
    'config.rcPlus.status.LastPing': {
      handler(newVal, oldVal) {
        if (newVal == oldVal) return;
        this.RcPlusCheack();
      },
      deep: true,
    }
  }
}
</script>
